import React from 'react';
import './OrderProcess.css'
import { MdProductionQuantityLimits } from "react-icons/md";
import { FaWpforms } from "react-icons/fa";
import { FiPhoneCall } from "react-icons/fi";
import { GrDeliver } from "react-icons/gr";





const OrderProcess = () => {
    return (
        <div className='processContainer'>
            <div>
                <MdProductionQuantityLimits className='processIcon'/>

                <p>পছন্দের পণ্য নির্বাচন করুন</p>
            </div>
            <div>
                <FaWpforms className='processIcon'/>

                <p>নিচের ফর্ম পূরণ করুন</p>
            </div>
            <div>
                <FiPhoneCall className='processIcon' />

                <p>আমাদের কনফার্মেশন কল রিসিভ করুন</p>
            </div>
            <div>
                <GrDeliver className='processIcon'/>

                <p>২–৩ দিনের মধ্যে হোম ডেলিভারি পান</p>
            </div>
        </div>
    );
};

export default OrderProcess;